import styled from 'styled-components';
import { HitArea as UrcHitArea, Accordion } from '@upgrade/react-components';
import { AccordionHeaderButton, AccordionHeaderIconStyled } from '@upgrade/react-components/Accordion/styles';
import { mb, mt, pl } from '@upgrade/react-components/Spacing/core';

export const FAQContainer = styled.div`
  ${mt('lg')};
  border-bottom: ${({ theme, $isLast }) => ($isLast ? 'none' : `1px solid ${theme.palette.border}`)};
`;

export const HitArea = styled(UrcHitArea)`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Dd = styled.dd`
  ${mb('lg')};
  ${mt('md')};
`;

export const Dl = styled.dl`
  width: 100%;

  a {
    text-decoration: none;
  }

  ul {
    ${pl('lg')}
  }

  .small-text {
    font-size: ${({ theme }) => theme.typography.sizes.text.desktop.xxs.fontSize};
  }
`;

export const StyledPanel = styled(Accordion.Panel)`
  /** remove padding to make it look as designed */
  ${AccordionHeaderButton} {
    padding: 1rem 0;
  }

  /** adding small spacing to prevent the icon to change the shape of the focus indicator when rotating */
  ${AccordionHeaderIconStyled} {
    margin-right: 0.5rem;
  }
`;

/**
 * The Accordion Panel content could ends with a p tag which has `margin-bottom: 1.5rem`. This
 * definition uses margin collapse to keep the spacing consistent.
 */
export const StyledAnswer = styled.div`
  margin-bottom: 1.5rem;
`;
